var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useState, } from 'react';
import { chainHandlers } from '../../../../utils/chain-handlers';
import { filteredStringList } from '../../../../utils/filtered-string-list';
import { FieldIcon } from '../../Elements/FieldIcon';
import { FieldInput } from '../../Elements/FieldInput';
import { FieldLabel } from '../../Elements/FieldLabel';
import { FieldSubText } from '../../Elements/FieldSubText';
import { PasswordVisibilityToggle } from '../../Elements/PasswordVisibilityToggle';
import { useFormatChange } from '../../validation/use-format-change';
import styles from './TextField.module.scss';
/**
 * @tdr
 * @tdr-candidates: input[type="text"]
 */
export var TextField = forwardRef(function (_a, ref) {
    var advisoryText = _a.advisoryText, ariaDescribedBy = _a.ariaDescribedBy, className = _a.className, dataWebviewid = _a.dataWebviewid, defaultValue = _a.defaultValue, disabled = _a.disabled, displayMaxLength = _a.displayMaxLength, errorText = _a.errorText, helpText = _a.helpText, helpTextIconHidden = _a.helpTextIconHidden, id = _a.id, indicateOptional = _a.indicateOptional, indicateRequired = _a.indicateRequired, _b = _a.inputMode, inputMode = _b === void 0 ? 'text' : _b, label = _a.label, labelHidden = _a.labelHidden, leadingIcon = _a.leadingIcon, maxLength = _a.maxLength, onChange = _a.onChange, onFormat = _a.onFormat, required = _a.required, trailingIcon = _a.trailingIcon, trailingIconOnClick = _a.trailingIconOnClick, trailingIconLabel = _a.trailingIconLabel, _c = _a.type, type = _c === void 0 ? 'text' : _c, value = _a.value, props = __rest(_a, ["advisoryText", "ariaDescribedBy", "className", "dataWebviewid", "defaultValue", "disabled", "displayMaxLength", "errorText", "helpText", "helpTextIconHidden", "id", "indicateOptional", "indicateRequired", "inputMode", "label", "labelHidden", "leadingIcon", "maxLength", "onChange", "onFormat", "required", "trailingIcon", "trailingIconOnClick", "trailingIconLabel", "type", "value"]);
    var _d = useState(value || ''), inputValue = _d[0], setInputValue = _d[1];
    var _e = useState(false), passwordVisible = _e[0], setPasswordVisible = _e[1];
    var formatChange = useFormatChange(onFormat);
    var hasError = !!errorText;
    var hasLeadingIcon = !!leadingIcon;
    var hasTrailingIcon = !!trailingIcon;
    var iconClassName = disabled && styles.iconDisabled;
    var isPassword = type === 'password';
    var displayCharacterCount = displayMaxLength && maxLength;
    var labelId = "".concat(id, "-label");
    var advisoryTextId = "".concat(id, "-advisoryText");
    var errorTextId = "".concat(id, "-errorText");
    var helpTextId = "".concat(id, "-helpText");
    var describedBy = filteredStringList([
        !!advisoryText && advisoryTextId,
        hasError && errorTextId,
        !!helpText && helpTextId,
        ariaDescribedBy,
    ]);
    return (React.createElement("div", { className: styles.container, "data-webviewid": dataWebviewid },
        React.createElement(FieldLabel, __assign({}, {
            id: labelId,
            indicateOptional: indicateOptional,
            indicateRequired: indicateRequired,
            label: label,
            labelForId: id,
            labelHidden: labelHidden,
        })),
        React.createElement(FieldSubText, { hideIcon: helpTextIconHidden, id: helpTextId, text: helpText, type: "help" }),
        React.createElement("div", { className: styles.input },
            React.createElement(FieldInput, __assign({}, __assign(__assign({}, props), { 'aria-describedby': describedBy, 'aria-invalid': hasError, 'aria-labelledby': labelId, 'aria-required': required, className: className, defaultValue: defaultValue, disabled: disabled, hasError: hasError, hasLeadingIcon: hasLeadingIcon, hasTrailingIcon: hasTrailingIcon, id: id, inputMode: inputMode, maxLength: maxLength, onChange: chainHandlers(formatChange === null || formatChange === void 0 ? void 0 : formatChange.onChange, function (e) { return setInputValue(e.target.value); }, onChange), ref: ref, required: required, type: isPassword && passwordVisible ? 'text' : type, value: value }))),
            hasLeadingIcon && (React.createElement(FieldIcon, { className: iconClassName, icon: leadingIcon, position: "leading" })),
            hasTrailingIcon && (React.createElement(FieldIcon, { className: iconClassName, icon: trailingIcon, onClick: trailingIconOnClick, label: trailingIconLabel }))),
        isPassword && (React.createElement(PasswordVisibilityToggle, { inputId: id, passwordVisible: passwordVisible, setPasswordVisible: setPasswordVisible })),
        React.createElement(FieldSubText, { id: errorTextId, text: errorText, type: "error" }),
        (advisoryText || displayCharacterCount) && (React.createElement("div", { className: styles.advisoryText },
            React.createElement(FieldSubText, { id: advisoryTextId, text: advisoryText, type: "advisory" }),
            displayCharacterCount && (React.createElement(FieldSubText, { className: styles.characterCount, text: "".concat(maxLength - inputValue.length, "/").concat(maxLength, " characters left"), type: "advisory" }))))));
});
//# sourceMappingURL=TextField.js.map